import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useNavigate } from "react-router-dom";

import { Button } from "@covertree/ui";
import {
  COVERTREE_EMAIL_ADDRESS,
  COVERTREE_PHONE_NUMBER,
} from "@covertree/consts";
import { resetPolicyTypeForm } from "@redux/coverages/coveragesSlice";
import useAppDispatch from "@redux/hooks/useAppDispatch";

export default function PolicyAlreadyAdded() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const handleClose = () => {
    dispatch(resetPolicyTypeForm());
    navigate(-1);
  };
  return (
    <Grid
      display="flex"
      direction="column"
      gap={5}
      alignItems="flex-start"
      justifyContent="space-around">
      <img src="/images/icons/cross.webp" alt="cross" width={80} />
      <Grid item xs={12}>
        <Typography fontSize={32}>Policy Already Added</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography fontSize={20}>
          This policy was already added to any resident profile. Please call a
          CoverTree agent at{" "}
          <Typography component="span" color="secondary.main">
            {COVERTREE_PHONE_NUMBER}
          </Typography>{" "}
          or email us at{" "}
          <Typography component="span" color="secondary.main">
            {COVERTREE_EMAIL_ADDRESS}
          </Typography>
        </Typography>
      </Grid>
      <Button onClick={handleClose}>Back</Button>
    </Grid>
  );
}
